import React from 'react';
import axios from 'axios';
import NewsCollapse from './NewsCollapse';

class News extends React.Component {
  apiEndpoint = 'https://lrfiosxbs6.execute-api.ap-northeast-2.amazonaws.com';
  imageBaseUrl = 'https://d1aummmer0n4kg.cloudfront.net/media/';

  state = {
    news_list: '',
    isLoading: true
  }

  resolveImageUrl = (image) => {
    if (!image) {
      return image;
    }

    if (
      image.startsWith('http://') ||
      image.startsWith('https://') ||
      image.startsWith('//')
    ) {
      return image;
    }

    return `${this.imageBaseUrl}${image.replace(/^\/+/, '')}`;
  }

  componentDidMount() {
    axios.get(`${this.apiEndpoint}/default/news`, {
      params: {
        type: 'all'
      }
    }).then((response) => {
      console.log(response);

      const items = response.data && Array.isArray(response.data.items) ? response.data.items : [];

      var news_list = items.map((news) => {
        return (
          <NewsCollapse
            id={news.id}
            key={news.id}
            title={news.title}
            timestamp={news.created}
            content={news.content}
            image={this.resolveImageUrl(news.image)}
          />
        )
      });

      this.setState({
        news_list: news_list,
        isLoading: false
      });
    }).catch((error) => {
      console.error(error);
      this.setState({ isLoading: false });
    });
  }

  render() {
    if (this.state.isLoading) {
      return (
        <div className="public-content-loading">
          <div className="public-content-spinner" />
        </div>
      );
    }

    return (
      <>
        <div className="news_list">
          {this.state.news_list}
        </div>
      </>
    );
  }
}

export default News;
